import axios from "axios";

export const state = {
    reportloanpermembers: [],
};

export const getters = {
    reportloanpermembers: state => state.reportloanpermembers,
};

export const mutations = {
    setReportLoansPerMember(reportloanpermembers, newValue) { state.reportloanpermembers = newValue},
};

export const actions = {
    async fetchReportLoansPerMember({ commit }) {
        await axios.get('/reportloanpermembers').then(res => {
            commit('setReportLoansPerMember', res.data.loans)
        })
    },
    async filterReportLoansPerMember({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterreportloanpermembers";
        await axios.post(url, formData).then((response) => {
            commit('setReportLoansPerMember', response.data.loans)
        })
    },
};
